export const emptyGuid = '00000000-0000-0000-0000-000000000000'
export const emptyIconLink = new URL('https://sun1-55.userapi.com/FjT-LG_GxrmQAKd4TqiQgh410Fqyb2r6NByuLg/WNLQg4iEz-k.png')
